import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import { toastError } from '@components/Toast';

import { fetchBrandProfileById } from '@store/actions/BrandProfileAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchCategoryAndSubCategories } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const CoreProduct = () => {
	const [subCategories, setSubCategories] = useState([]);
	const [coreProducts, setCoreProducts] = useState([]);
	const brandProfileStore = useSelector((store) => store.brandProfileStore);
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		const initialObj = { subCategory: {}, minPrice: null, maxPrice: null };
		if (brandProfileStore.brandCoreProductSubcategoryList?.length > 0) {
			let tmpData = brandProfileStore.brandCoreProductSubcategoryList.map((item) => ({
				subCategory: { value: item.productSubCategoryName, label: item.productSubCategoryId },
				minPrice: item.minPrice,
				maxPrice: item.maxPrice
			}));
			setCoreProducts([...tmpData, initialObj]);
		} else {
			setCoreProducts([initialObj]);
		}
	}, [brandProfileStore]);

	useEffect(() => {
		fetchCategoryAndSubCategories().then((data) => {
			let tmpCategories = [];
			for (let cat of data) {
				for (let item of cat.subCategoryResponseList) {
					tmpCategories.push({ value: item.name, label: item.id });
				}
			}
			setSubCategories(tmpCategories);
		});
	}, []);

	const onItemClick = (data, index) => {
		let cloneProducts = [...coreProducts];
		cloneProducts[index].subCategory = data;
		setCoreProducts(cloneProducts);
		handleBlur(cloneProducts, index);
	};

	const handleChange = (e, index) => {
		const { name, value } = e.target;
		let cloneProducts = [...coreProducts];
		cloneProducts[index][name] = value;
		setCoreProducts(cloneProducts);
	};

	const handleBlur = async (products, index) => {
		let cloneProducts = products.filter(
			(item) => Object.keys(item.subCategory).length === 0 || !item.minPrice || !item.maxPrice
		);
		if (cloneProducts.length === 0) {
			setCoreProducts((prev) => [...prev, { subCategory: {}, minPrice: null, maxPrice: null }]);
		}
		let validProducts = products.filter(
			(item) => Object.keys(item.subCategory).length > 0 && item.minPrice && item.maxPrice
		);
		if (
			validProducts.length > 0 &&
			Object.keys(products[index].subCategory).length > 0 &&
			products[index].minPrice &&
			products[index].maxPrice
		) {
			try {
				dispatch(openLoader());
				const postData = validProducts?.map((item) => ({
					brandId: parseInt(id),
					productSubCategoryId: item.subCategory.label,
					productSubCategoryName: item.subCategory.value,
					minPrice: item.minPrice,
					maxPrice: item.maxPrice
				}));
				await ApiClient.POST(`${BASE_URL}/brand/${id}/core-product-category`, postData, '', true);
				dispatch(fetchBrandProfileById(id));
				dispatch(closeLoader());
			} catch (error) {
				toastError(error.message);
				dispatch(closeLoader());
			}
		}
	};

	return (
		<>
			{coreProducts?.map((item, index) => (
				<div className="d-flex mb-2" key={`core_product_${index}`}>
					<div className="form-group type mb-0 mr-12">
						<CustomDropdown
							type="addItem"
							title={''}
							toolTipLength={15}
							isShowLabel={false}
							onItemClick={(value) => onItemClick(value, index)}
							items={subCategories}
							selectedItem={item?.subCategory?.value || ''}
						/>
					</div>
					<div className="form-group mb-0 mr-12">
						<input
							type="number"
							onChange={(e) => handleChange(e, index)}
							value={item.minPrice || ''}
							name="minPrice"
							placeholder="$Min"
							onBlur={() => handleBlur(coreProducts, index)}
						/>
					</div>
					<div className="form-group mb-0 mr-12">
						<input
							type="number"
							onChange={(e) => handleChange(e, index)}
							value={item.maxPrice || ''}
							name="maxPrice"
							placeholder="$Max"
							onBlur={() => handleBlur(coreProducts, index)}
						/>
					</div>
				</div>
			))}
		</>
	);
};

export default CoreProduct;
